/** Figure professionali per firma PAI (chiave API ↔ etichetta UI). */
export const PAI_FIRMA_ROLES = [
  { key: "oss", label: "OSS" },
  { key: "responsabile_struttura", label: "Responsabile di struttura" },
  { key: "assistente_sociale", label: "Assistente sociale" },
  { key: "educatore_professionale", label: "Educatore professionale" },
  { key: "psicologo", label: "Psicologo/a" },
  { key: "familiare", label: "Familiare" },
];

export function createEmptyPaiFirmeState() {
  const figure = {};
  for (const { key } of PAI_FIRMA_ROLES) {
    figure[key] = { firmato_da: "", png: null };
  }
  return {
    luogo: "",
    data: new Date().toISOString().split("T")[0],
    figure,
  };
}

/** Raccoglie firme dallo stato (png già persistite per figura). */
export function collectPaiFirmePayload(firmeState) {
  const firme = {};
  for (const { key } of PAI_FIRMA_ROLES) {
    const png = firmeState.figure?.[key]?.png;
    if (png) {
      firme[key] = {
        png,
        firmato_da: (firmeState.figure?.[key]?.firmato_da || "").trim(),
      };
    }
  }
  return {
    firme,
    firme_luogo: (firmeState.luogo || "").trim(),
    firme_data: firmeState.data || "",
  };
}

export function countPaiFirmeCompilate(firmeState) {
  return PAI_FIRMA_ROLES.filter(({ key }) => Boolean(firmeState.figure?.[key]?.png)).length;
}

/** Unisce la firma corrente sul canvas nello stato della figura attiva. */
export function mergeActiveSignatureIntoState(firmeState, activeRole, sigRef) {
  const ref = sigRef?.current;
  if (!ref || ref.isEmpty()) {
    return {
      ...firmeState,
      figure: {
        ...firmeState.figure,
        [activeRole]: {
          ...firmeState.figure?.[activeRole],
          png: null,
        },
      },
    };
  }
  return {
    ...firmeState,
    figure: {
      ...firmeState.figure,
      [activeRole]: {
        ...firmeState.figure?.[activeRole],
        png: ref.toDataURL("image/png"),
      },
    },
  };
}

export function isPaiFirmaRoleSigned(firmeState, activeRole, sigRef, roleKey) {
  if (roleKey === activeRole) {
    const ref = sigRef?.current;
    if (ref && !ref.isEmpty()) return true;
  }
  return Boolean(firmeState.figure?.[roleKey]?.png);
}
